angular.module('impactx.hierarchyselect').directive('ixHierarchySelect', function () {
    return {
        restrict: 'E',
        controller: 'HierarchySelectCtrl',
        controllerAs: 'hierarchySelectCtrl',
        templateUrl: 'shared/hierarchyselect/templates/hierarchy-select.tmpl.html',
        scope: {
            ngModel: "=?",
            rootNode: '=items',
            placeholder: '@',
            onItemChange: '&?',
            onNodeChange: '&?',
            inputName: '@?'
        },
        link: function (scope, element) {
            scope.mdAutocompleteCtrl = element.find('md-autocomplete').controller('mdAutocomplete');
            scope.$watch("ngModel", function (newValue) {
                if (newValue) {
                   scope.searchText = newValue.name;
                }
            });
        }
    }
});
